<div class="retailer-data-page">
    <div class="retailer-data-button">
        <p>{{ 'retailerData.explanation' | translate }}</p>
        <div class="button-container">
            <app-button
                [buttonType]="'secondary'"
                [label]="'retailerData.download' | translate"
                (click)="downloadRetailerData()"
            ></app-button>
            @if (hasEditRetailerDataPermission$ | async) {
                <app-button
                    [buttonType]="'secondary'"
                    [label]="'retailerData.upload' | translate"
                    (click)="fileInputXLSX.click()">
                    <input #fileInputXLSX type="file" class="file-upload" hidden
                           (change)="uploadRetailerData($event)">
                </app-button>
            }
        </div>
    </div>
</div>

